__turbopack_context__.v({
  "button-text": "styles-module__QFocoG__button-text",
  "copy-button": "styles-module__QFocoG__copy-button",
  "copy-message": "styles-module__QFocoG__copy-message",
  "copy-text-wrapper": "styles-module__QFocoG__copy-text-wrapper",
});
